export default __webpack_public_path__ + "static/media/ic_cm_story.ebb6e718.svg";